import React from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsReact from "highcharts-react-official";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader";

// if (typeof Highcharts === "object") {
//   Highcharts3D(Highcharts);
// }

const ActualGenerationChart = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const {
    data: actualGenerationData = [],
    isLoading: actualGenerationIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "actual_generation_in_mu",
    lang: languageType,
  });

  const options = {
    chart: {
      type: "column",
      options3d: {
        enabled: true,
        alpha: 35,
        beta: 0,
        depth: 75,
        viewDistance: 125,
      },
    },
    title: {
      text: getText("Actual Generation in MU", "एमयू में वास्तविक उत्पादन"),
      align: "left",
    },
    xAxis: {
      // categories: [
      //   "2019 - 2020",
      //   "2020 - 2021",
      //   "2021 - 2022",
      //   "2022 - 2023",
      //   "2023 - 2024",
      // ],
      categories: actualGenerationData?.map(
        (item) => item?.field_actual_generation_year ?? null
      ),
      title: {
        text: "Month",
      },
    },
    yAxis: {
      min: 0,
      tickInterval: 2000,
      title: {
        text: getText("Generation (MU)", "उत्पादन(एमयू)"),
      },
    },
    tooltip: {
      headerFormat: "<b>{point.key}</b><br>",
      pointFormat: "Generation: {point.y}",
      shared: true,
      useHTML: true,
      valueDecimals: 3,
    },
    plotOptions: {
      column: {
        depth: 40,
      },
    },
    series: [
      {
        name: getText("Actual Generation in MU", "वास्तविक उत्पादन (एमयू)"),
        // data: [8000.87, 8492, 8120.29, 6870, 6388],
        data: actualGenerationData?.map((item) =>
          parseFloat(item?.field_generation_capacity_in_mu ?? null)
        ),
        colorByPoint: true,
        //   colors: ["brown"],
      },
    ],
  };
  if (actualGenerationIsLoading) {
    return <Loader />;
  }
  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default ActualGenerationChart;
